import React from "react";
import { Sidebar } from "primereact/sidebar";

import api from "./../services/api";

export const SettingsContext = React.createContext({});

export const SettingsProvider = (props: any) => {
  const [settings, setSettings] = React.useState({});

  const [visibleError, setVisibleError] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<string>("");

  const loadSetting = () => {
    const data = localStorage.getItem("@innovaContol_current_settings");
    if (data) setSettings(JSON.parse(data));

    // api.get(`/configurations`)
    //   .then(response => {
    //     setSettings(response.data);
    //     localStorage.setItem("@innovaContol_current_settings", JSON.stringify(response.data));
    //   })
    //   .catch(error => {
    //     localStorage.removeItem("@innovaContol_current_settings");
    //   });
  };

  React.useEffect(() => {
    loadSetting();
  }, []);

  return (
    <SettingsContext.Provider value={{ ...settings, loadSetting: loadSetting, setVisibleError, setErrorMessage }}>
      {props.children}
      <Sidebar visible={visibleError} onHide={() => setVisibleError(false)} baseZIndex={1000000} position="bottom">
        <h3 style={{ fontWeight: "normal" }} className="text-center">
          {errorMessage}
        </h3>
      </Sidebar>
    </SettingsContext.Provider>
  );
};

export const useSettings = () => React.useContext<any>(SettingsContext);
